"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAPI = getAPI;
exports.login = login;
exports.getInfo = getInfo;
exports.logout = logout;

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _store = _interopRequireDefault(require("@/store"));

function getAPI(action) {
  var prefix = '';
  var postfix = '';

  if (action === 'login') {
    postfix = 'Login';
  } else if (action === 'info') {
    postfix = 'Info';
  }

  switch (_store.default.getters.mode) {
    case "admin":
      prefix = 'admin';
      break;

    case "agent":
      prefix = 'agent';
      break;

    case "merchant":
      prefix = 'merch';
      break;

    default:
      break;
  }

  return "".concat(prefix).concat(postfix);
}

function login(data) {
  return _httpUtils.default.post("login", getAPI('login'), null, data, null, 'skip');
}

function getInfo() {
  return _httpUtils.default.post("login", getAPI("info"), null, null, null, 'skip');
}

function logout() {
  return _httpUtils.default.post("login", "logout", null, null, null);
}